import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import React from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import { CreateView, IndexView, withBreadCrumbs } from "lego-gui-lib/lib";
import {
  ReportSubscriptionSchemaColumns,
  ReportSubscriptionSchemaForm
} from "./schema";
import {
  TabContentContainer,
  TabTitleContainer,
  TabViewContainer
} from "../../common/tabContainers";
import { ParentRoute } from "../../core/model/parent";
import { ReportSubscriptionShowView } from "./ReportSubscriptionShowView";

export const ReportSubscriptionViewComponent = () => {
  const match = useRouteMatch();
  const baseUrl = match.path;
  return (
    <>
      <ParentRoute
        dataSourceName={"reportSubscription"}
        path={baseUrl + "/:id"}
      />
      <Switch>
        <Route exact={true} path={baseUrl} component={Index} />
        <Route path={baseUrl + "/create/:id"} component={Create} />
        <Route path={baseUrl + "/create"} component={Create} exact={true} />
        <Route path={baseUrl + "/:id"} component={ReportSubscriptionShowView} />
      </Switch>
    </>
  );
};

const injectDataSource = (comp: any) =>
  inject("reportSubscription", "i18n", "SAN", "router")(observer(comp));

export const Index = injectDataSource(
  ({ reportSubscription, i18n, SAN, ...rest }: any) => {
    const title = i18n.t("hns:reportSubscription:domain", { count: 2 });
    return (
      <IndexView
        dataSource={reportSubscription.listDataSource}
        {...rest}
        title={title}
        titleVariant={"h5"}
        toolbarButtons={{ delete: true, export: true }}
        rowButtons={{ edit: true, delete: true, copy: true, export: true }}
        columns={ReportSubscriptionSchemaColumns}
        titleContainer={TabTitleContainer}
        viewContainer={TabViewContainer}
        contentContainer={TabContentContainer}
      />
    );
  }
);

export const Create = injectDataSource(
  ({ reportSubscription, i18n, SAN, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:reportSubscription:domain"
    });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url, children: title },
      <CreateView
        dataSource={reportSubscription.oneDataSource}
        {...rest}
        title={title}
        fields={ReportSubscriptionSchemaForm}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);
